module.exports = __webpack_public_path__ + "static/media/140.d46999d1.png";